// Moken optimised card swatch gallery.
// Instant, preloaded variant-image swap on swatch hover — no slideshow/carousel.
// Reads the existing 4.1.1 swatch markup (label[data-media-id] /
// input[data-option-media-id]) inside the product card, so it needs no changes
// to product-card.js and adds no duplicate swatches.

class MokenSwatchGallery extends HTMLElement {
  connectedCallback() {
    this.imgs = Array.from(this.querySelectorAll('.moken-card-gallery__img'));
    if (!this.imgs.length) return;

    const defaultImg =
      this.querySelector('.moken-card-gallery__img[data-default]') || this.imgs[0];
    this._defaultId = defaultImg ? defaultImg.dataset.mediaId : null;

    const card =
      this.closest('product-card') || this.closest('.product-card') || this.parentElement;
    this.picker = card ? card.querySelector('swatches-variant-picker-component') : null;
    if (!this.picker) return;

    // Delegated hover: any element carrying a media id inside the swatch picker.
    this._onOver = (event) => {
      const target = event.target.closest('[data-media-id], [data-option-media-id]');
      if (!target) return;
      const id = target.dataset.mediaId || target.dataset.optionMediaId;
      if (id) this.show(id);
    };
    // Leaving the swatches reverts to the selected/default image.
    this._onLeave = () => this.show(this._defaultId);
    // Selecting a swatch makes that image the new default.
    this._onChange = (event) => {
      const input = event.target.closest('input[data-option-media-id]');
      if (input && input.dataset.optionMediaId) {
        this._defaultId = input.dataset.optionMediaId;
        this.show(this._defaultId);
      }
    };

    this.picker.addEventListener('pointerover', this._onOver);
    this.picker.addEventListener('pointerleave', this._onLeave);
    this.picker.addEventListener('change', this._onChange);
  }

  disconnectedCallback() {
    if (!this.picker) return;
    this.picker.removeEventListener('pointerover', this._onOver);
    this.picker.removeEventListener('pointerleave', this._onLeave);
    this.picker.removeEventListener('change', this._onChange);
  }

  /** Activate the image whose data-media-id matches; no-op if not present. */
  show(id) {
    if (id == null) return;
    const sid = String(id);
    if (!this.imgs.some((img) => img.dataset.mediaId === sid)) return;
    for (const img of this.imgs) {
      img.classList.toggle('is-active', img.dataset.mediaId === sid);
    }
  }
}

if (!customElements.get('moken-swatch-gallery')) {
  customElements.define('moken-swatch-gallery', MokenSwatchGallery);
}
